import Select from "react-select";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// styles and images
import Close from "../../assets/close.svg";

// internal hooks
import { useEscape } from "../../hooks/useEscape";

// store
import { adminDataStore, messageAndErrorStore, userStore } from "../../store/Store";
import InputField from "../../formComponents/InputField";
import FormButton from "../../formComponents/FormButton";
import { useGetOptions } from "../../hooks/useGetOptions";

export default function AddEditAdminUser({ setAddTrigger }) {
  const JwtToken = userStore((userDataStore) => userDataStore.JwtToken);
  const currentUser = userStore((userDataStore) => userDataStore.currentUser);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const adminCompanyData = adminDataStore((data) => data.adminCompanyData);
  const setAdminUsers = adminDataStore((data) => data.setAdminUsers);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)

  // state
  const [pending, setPending] = useState(false);
  const [companyDD, setCompanyDD] = useState();
  const [user, setUser] = useState({
    id: 0,
    email: "",
    first_name: "",
    last_name: "",
    company_id: 0,
    created_by_id: 0,
    updated_by_id: 0,
  });
  const navigate = useNavigate();

  useEscape(setAddTrigger, [], [], pending);

  const handleClose = () => {
    setAddTrigger(false);
  };

  const handleChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelect = (option, e) => {
    setUser({
      ...user,
      [e.name]: option.value,
    });
  };

  useGetOptions(setCompanyDD, adminCompanyData, ...Array(2), "company_name");

  const handleSubmit = (e) => {
    setPending(true);
    e.preventDefault();
    const controller = new AbortController();
    const requestBody = user;
    requestBody.created_by_id = currentUser.id;
    requestBody.updated_by_id = currentUser.id;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);

    const requestOptions = {
      body: JSON.stringify(requestBody),
      method: "POST",
      headers: headers,
    };
    fetch(
      `${process.env.REACT_APP_BACKEND}/admin/user/${user.id}`,
      requestOptions
    )
      .then((res) => {
        if (!res.ok) {
          if (res.status === 401) {
            setAuthStatus(false);
            setPending(false);
            setAddTrigger(false);
            navigate("/login");
          } else if (res.status === 409) {
            setPending(false);
            toggleNewMessage("This user already exists");
            return Promise.resolve();
          } else {
            toggleNewMessage(`Something Went Wrong Status: ${res.status}`);
            setPending(false);
            return Promise.resolve();
          }
        } else {
          return res.json();
        }
      })
      .then((data) => {
        if (!data) {
          setPending(false);
        } else {
          setAdminUsers(data);
          setAddTrigger(false);
          toggleNewMessage(null, "Success");
        }
      })
      .catch((err) => {
        toggleNewMessage("Something went wrong");
        setPending(false);
        return;
      })
      .finally(() => {
        setPending(false);
      });
    return () => controller.abort();
  };

  return (
    <div className="popup">
      <div className="popup-inner">
        {!pending && (
          <div className="close">
            <img onClick={handleClose} src={Close} alt="close" />
          </div>
        )}
        <h3>Add User</h3>
        <form onSubmit={handleSubmit}>
          <InputField
            name={"first_name"}
            title={"First Name"}
            type={"text"}
            className={"form-control"}
            value={user.first_name}
            onChange={handleChange}
            required={true}
          />
          <InputField
            name={"last_name"}
            title={"Last Name"}
            type={"text"}
            className={"form-control"}
            value={user.last_name}
            onChange={handleChange}
            required={true}
          />
          <InputField
            name={"email"}
            title={"Email"}
            type={"text"}
            className={"form-control"}
            value={user.email}
            onChange={handleChange}
            required={true}
          />
          <div className="mb-3">
            <label className="form-label">Company</label>
            <Select
              name="company_id"
              options={companyDD}
              onChange={handleSelect}
            />
          </div>
          <FormButton pending={pending} name={"Add User"} />
        </form>
      </div>
    </div>
  );
}
